import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";
Vue.use(Vuetify);

const theme = {
  primary: "#1a237e",
  info: "#283593",
  success: "#2e7d32",
  accent: "#303f9f",
  default: "#1a237e",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false,
  },
  rtl: false,
});
